import React, { useState, useEffect } from "react";
import { Grid, Typography, ButtonBase } from "@mui/material";
import { db, storage } from "../../../firebase/firebase";
import { collection, addDoc, getDocs, onSnapshot } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import uploadImg from "../../../Recursos/subir.svg";
import { useResponsive } from "../../../Modulo_Responsive/Hooks/useResponsive";

const Cono_Gratis = ({ textos = {} }) => {
    const { sCell } = useResponsive();
    const [imagen, setImagen] = useState(null);
    const [archivo, setArchivo] = useState(null);
    const [subiendo, setSubiendo] = useState(false);
    const [urlsTituloPrincipal, setUrlsTituloPrincipal] = useState([]);

    useEffect(() => {
        const unsub = onSnapshot(collection(db, "cono-titulo-principal"), (snap) => {
            const docs = snap.docs.map(d => ({ id: d.id, ...d.data() }));
            docs.sort((a, b) => {
                if (a.orden !== undefined && b.orden !== undefined) return a.orden - b.orden;
                if (a.numero !== undefined && b.numero !== undefined) return a.numero - b.numero;
                return 0;
            });
            setUrlsTituloPrincipal(docs.map(d => d.url).filter(Boolean));
        });
        return () => unsub();
    }, []);

    const manejarSeleccion = (e) => {
        const selected = e.target.files[0];
        if (selected) { setArchivo(selected); setImagen(URL.createObjectURL(selected)); }
    };

    const manejarEnviar = async () => {
        if (!archivo) { alert("Por favor selecciona una imagen primero."); return; }
        setSubiendo(true);
        try {
            const storageRef = ref(storage, `cono-gratis/${archivo.name}-${Date.now()}`);
            await uploadBytes(storageRef, archivo);
            const url = await getDownloadURL(storageRef);
            const colRef = collection(db, "cono-gratis");
            const snapshot = await getDocs(colRef);
            const numero = snapshot.size + 1;
            await addDoc(colRef, { url, nombre: archivo.name, fecha: new Date(), numero });
            alert(`✅ Imagen subida con éxito. Número asignado: ${numero}`);
            setArchivo(null);
            setImagen(null);
        } catch (error) {
            console.error("❌ Error al subir la imagen:", error);
            alert("Error al subir la imagen. Revisa la consola.");
        } finally {
            setSubiendo(false);
        }
    };

    return (
        <Grid container justifyContent={"center"} alignItems={"center"} size={{ xs: 12, sm: 12, md: 12 }}>

            {/* Imágenes título principal */}
            <Grid container direction="column" justifyContent={"center"} alignItems={"center"} size={{ xs: 12, sm: 12, md: 12 }}>
                {urlsTituloPrincipal.length > 0 ? (
                    urlsTituloPrincipal.map((url, i) => (
                        <img key={i} src={url} alt="¿Cómo ganar un cono gratis?"
                             style={{ width: sCell ? "100%" : 640, display: "block" }}
                             loading="lazy"
                        />
                    ))
                ) : (
                    <Grid container justifyContent={"center"} size={{ xs: 12, sm: 8, md: 5 }}>
                        <Typography component="h1" sx={{ fontFamily: 'Abril Fatface', fontSize: sCell ? 32 : 48, fontWeight: 600, textAlign: "center", color: "black" }}>
                            {textos.cono_titulo_principal || "¿Cómo ganar un cono gratis?"}
                        </Typography>
                    </Grid>
                )}
            </Grid>

            {/* Subir imagen */}
            <Grid container justifyContent={"center"} alignItems={"center"} size={{ xs: 12, sm: 8, md: 5 }} sx={{ pt: 4, px: 3 }}>
                <Grid container justifyContent={"center"} alignItems={"center"} sx={{ backgroundColor: "#FFA500", borderRadius: "32px", width: "100%", minHeight: "250px", p: 3 }}>
                    {!imagen ? (
                        <>
                            <Grid container size={{ xs: 12, sm: 12, md: 6 }} justifyContent={"center"} alignItems={"center"}>
                                <img src={uploadImg} alt="Subir archivo" style={{ width: "80px", height: "80px" }} />
                                <Grid container size={{ xs: 12, sm: 12, md: 12 }} justifyContent={"center"} alignItems={"center"}>
                                    <Typography component="p" sx={{ color: "white", fontSize: 16, fontWeight: 500, textAlign: "center", maxWidth: "250px" }}>
                                        Arrastra la captura de pantalla aquí
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Grid container size={{ xs: 12, sm: 12, md: 6 }} justifyContent={"center"} alignItems={"center"}>
                                <ButtonBase component="label" sx={{ backgroundColor: "#CC6F0F", color: "white", borderRadius: "20px", fontWeight: 500, px: 3, py: 1, "&:hover": { backgroundColor: "#CC6F0F" }, mt: 2 }}>
                                    <Typography component="p" sx={{ color: "white", fontSize: 16, fontWeight: 500, textAlign: "center" }}>
                                        Seleccionar del dispositivo
                                    </Typography>
                                    <input type="file" hidden accept="image/*" onChange={manejarSeleccion} />
                                </ButtonBase>
                            </Grid>
                        </>
                    ) : (
                        <>
                            <img src={imagen} alt="Vista previa" style={{ maxWidth: "100%", borderRadius: "12px", marginBottom: "16px" }} />
                            <Grid container justifyContent="center" spacing={6}>
                                <Grid item xs={6}>
                                    <ButtonBase component="label" sx={{ backgroundColor: "#CC6F0F", color: "white", borderRadius: "20px", px: 3, py: 1, width: "100%", "&:hover": { backgroundColor: "#CC6F0F" } }}>
                                        Cambiar
                                        <input type="file" hidden accept="image/*" onChange={manejarSeleccion} />
                                    </ButtonBase>
                                </Grid>
                                <Grid item xs={6}>
                                    <ButtonBase onClick={manejarEnviar} sx={{ backgroundColor: "#CC6F0F", color: "white", borderRadius: "20px", px: 4, py: 1, width: "100%", "&:hover": { backgroundColor: "#CC6F0F" } }}>
                                        {subiendo ? "Subiendo..." : "Enviar"}
                                    </ButtonBase>
                                </Grid>
                            </Grid>
                        </>
                    )}
                </Grid>
            </Grid>
        </Grid>
    );
};

export default Cono_Gratis;